import { useAuth } from '../lib/auth';
import { useMyBoatPlaces, useMyBoats } from '../lib/boats';
import BoatPlaceList from '../components/BoatPlaceList';

export default function MyBoatPlaces() {
  const { user } = useAuth();
  const uid = user?.uid ?? null;
  const { places, loading: placesLoading, error: placesError } = useMyBoatPlaces(uid);
  const { boats, loading: boatsLoading, error: boatsError } = useMyBoats(uid);

  if (placesLoading || boatsLoading) {
    return <p className="text-sm text-gray-500">Laddar…</p>;
  }
  if (placesError || boatsError) {
    return (
      <p className="text-bad">
        Kunde inte ladda dina båtplatser. Försök igen senare.
      </p>
    );
  }
  if (places.length === 0) {
    return (
      <p className="text-sm text-gray-600">
        Du har inga båtplatser registrerade. Kontakta styrelsen om du tror att
        det är fel.
      </p>
    );
  }
  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">Mina båtplatser</h1>
      <BoatPlaceList places={places} boats={boats} />
    </section>
  );
}
